export default class Scrolly {
  constructor(element) {
    this.element = element;
    this.options = {
      rootMargin: '0px',
      noRepeat: false,
    };
    this.setOptions();
    this.init();
  }

  setOptions() {
    console.log(this.element.dataset);
    if ('noRepeat' in this.element.dataset) {
      this.options.noRepeat = true;
    }
  }

  init() {
    const observer = new IntersectionObserver(
      this.watch.bind(this),
      this.options
    );

    const items = this.element.querySelectorAll('[data-scrolly]');
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      observer.observe(item);
    }
  }

  watch(entries, observer) {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const target = entry.target;

      if (entry.isIntersecting) {
        //console.log('oui');
        target.classList.add('is-active');
        if (this.options.noRepeat || 'noRepeat' in target.dataset) {
          console.log('no repeat');
          observer.unobserve(target);
        }
      } else {
        //console.log('non');
        target.classList.remove('is-active');
      }
    }
  }
}
